import { render, staticRenderFns } from "./BrandsMarketplace.vue?vue&type=template&id=82d99744&scoped=true&"
import script from "./BrandsMarketplace.vue?vue&type=script&lang=js&"
export * from "./BrandsMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./BrandsMarketplace.vue?vue&type=style&index=0&id=82d99744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d99744",
  null
  
)

export default component.exports